import { useEffect } from "react";

const useActivityTracker = (onActive) => {
  useEffect(() => {
    const events = ["mousemove", "keydown", "click"];
    const handleActivity = () => onActive(Date.now());

    events.forEach((event) => window.addEventListener(event, handleActivity));
    return () => events.forEach((event) => window.removeEventListener(event, handleActivity));
  }, [onActive]);
};

export default useActivityTracker;
